import React from 'react';

const donutData = [
  { id: 1, name: 'Apple Pie Donut', image: '/donuts/apple.png' },
  { id: 2, name: 'Frosted Donut', image: '/donuts/frosted.png' },
  { id: 3, name: 'Reeses Topped Donut', image: '/donuts/reesestopped.png' },
  { id: 4, name: 'Lemon Poppyseed Donut', image: '/donuts/lemonpoppy.png' },
  { id: 5, name: 'Donut Hole', image: '/donuts/donutholesmenu.png' },
  { id: 6, name: 'Maple Bacon Donut', image: '/donuts/baconmaplemenu.png' },
  { id: 7, name: 'Cake Donut', image: '/donuts/cakemenu.png' },
  { id: 8, name: 'Pecan Donut', image: '/donuts/pecanmenu.png' },
  { id: 9, name: 'Strawberry Jam Donut', image: '/donuts/stjammenu.png' },
  { id: 10, name: 'Lemon & Meringue Pie Donut', image: '/donuts/lemonmenu.png' },
  { id: 11, name: 'Oreo Donut', image: '/donuts/oreomenu.png' },
  { id: 12, name: 'Original Glazed', image: '/donuts/glazemenu.png' },
  { id: 13, name: 'Apple Fritters', image: '/donuts/afrittersmenu.png' },
  { id: 14, name: 'Unicorn Donut', image: '/donuts/sjammenu.png' },
  { id: 15, name: 'Dog Treat', image: '/donuts/dtreatmenu.png' }
];

const Menu: React.FC = () => {
  return (
    <div className="pt-16 sm:pt-18 lg:pt-16 min-h-screen bg-cream">
      {/* Hero Header */}
      <div className="bg-gradient-to-b from-orange-50 to-cream py-10 sm:py-12 lg:py-16">
        <div className="container-base text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-pacifico text-orange-500 mb-2 sm:mb-3">Our Donuts</h1>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-xl mx-auto px-4">
            Handcrafted fresh every day with local love & quality ingredients
          </p>
        </div>
      </div>

      {/* Donut Grid */}
      <section className="section-sm">
        <div className="container-base">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-5 lg:gap-6">
            {donutData.map((donut) => (
              <div
                key={donut.id}
                className="group card card-hover overflow-hidden"
              >
                <div className="aspect-square bg-gradient-to-br from-orange-50 to-orange-100/30 p-5 sm:p-6 flex items-center justify-center">
                  <img
                    src={donut.image}
                    alt={donut.name}
                    className="w-full h-full object-contain drop-shadow-lg transition-transform duration-300 group-hover:scale-110"
                  />
                </div>
                <div className="p-3 sm:p-4 text-center border-t border-gray-100">
                  <h3 className="text-body-sm sm:text-body font-semibold text-gray-800">{donut.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Drinks Section */}
      <section className="section bg-white">
        <div className="container-base">
          <div className="text-center mb-10">
            <h2 className="section-title">Our Drinks</h2>
          </div>

          <div className="card-elevated overflow-hidden max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 items-stretch">
              {/* Image */}
              <div className="bg-gradient-to-br from-orange-50 to-orange-100/30 p-8 flex items-center justify-center">
                <img
                  src="/donuts/lotus-energy.png"
                  alt="Lotus Energy"
                  className="w-full max-w-xs rounded-xl shadow-card transition-transform duration-300 hover:scale-105"
                />
              </div>

              {/* Drinks Info */}
              <div className="p-6 sm:p-8 lg:p-10 flex flex-col justify-center">
                <div className="space-y-5">
                  {[
                    {
                      title: 'Specialty Drinks',
                      desc: 'Choose from 30+ flavored syrups to create your perfect drink. Add boba for a little extra fun!'
                    },
                    {
                      title: 'Coffee',
                      desc: 'Our smooth 16oz house coffee, served hot or iced. Perfectly roasted and ready to go.'
                    },
                    {
                      title: 'Other Beverages',
                      desc: 'Orange • Apple • Milk • Soda • Bottled Water',
                    }
                  ].map((drink, i) => (
                    <div key={i} className="bg-orange-50 rounded-xl p-4 sm:p-5">
                      <h3 className="text-h4 text-orange-500 mb-2">{drink.title}</h3>
                      <p className="text-body-sm text-gray-700 leading-relaxed">{drink.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Menu;
